import React from 'react';
import styles from '../styles';
import googlePlayBadge from '../assets/google-play-badge.png';
import useMediaQuery from '../hooks/useMediaQuery';
import { useLanguage } from '../contexts/LanguageContext';
import WhatsAppButton from './WhatsAppButton';

const CallToAction = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const { t } = useLanguage();

    const ctaStyles = {
        container: {
            ...styles.section,
            background: `linear-gradient(135deg, ${styles.brandColor} 0%, #8E0000 100%)`,
            color: '#FFFFFF',
            padding: isMobile ? '3rem 1rem' : '4rem 2rem',
            textAlign: 'center', // Center align text
        },
        headline: {
            ...styles.h2,
            color: '#FFFFFF',
            fontSize: isMobile ? '2rem' : '2.5rem',
        },
        subheading: {
            ...styles.subheading,
            color: '#f8f9fa',
            marginBottom: '2rem',
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center',
        },
        ctaButton: {
            height: '60px',
            cursor: 'pointer',
        }
    };

    return (
        <section id="download" style={ctaStyles.container}>
            <h2 style={ctaStyles.headline}>{t('cta.headline')}</h2>
            <p style={ctaStyles.subheading}>
                {t('cta.subheading')}
            </p>
            <div style={ctaStyles.buttonContainer}>
                <a href="https://play.google.com/store/apps/details?id=com.retterplus.android" target="_blank" rel="noopener noreferrer">
                    <img src={googlePlayBadge} alt={t('hero.getItOnGooglePlay')} style={ctaStyles.ctaButton} />
                </a>
                <WhatsAppButton style={{ height: '60px', borderRadius: '8px', padding: '0 1.5rem', fontSize: '1.2rem', marginLeft: 0 }} />
            </div>
        </section>
    );
};

export default CallToAction;
